const APP_PREFIX_PATH = '/app';
const AUTH_PREFIX_PATH = '/auth';

export { APP_PREFIX_PATH, AUTH_PREFIX_PATH };
